// idea taken from: https://tkdodo.eu/blog/effective-react-query-keys
// ToDo: consider https://github.com/lukemorales/query-key-factory
export const getQueryKeys = keyName => {
  const queryKeys = {
    all: [keyName],
    lists: () => [...queryKeys.all, 'list'],
    list: filters => [...queryKeys.lists(), removeEmpty(filters)],
    details: () => [...queryKeys.all, 'detail'],
    detail: id => [...queryKeys.details(), id],
    summaries: () => [...queryKeys.all, 'summary'],
    summary: id => [...queryKeys.summaries(), id],
  };

  return queryKeys;
};

export function removeEmpty(obj = {}) {
  return Object.keys(obj)
    .filter(k => obj[k] !== null)
    .reduce((a, k) => ({...a, [k]: obj[k]}), {});
}

export const DURATION_MS = {
  SECOND: 1 * 1000,
  MINUTE: 60 * 1000,
  FIVE_MINUTES: 5 * 60 * 1000,
  HOUR: 60 * 60 * 1000,
  TWELVE_HOURS: 12 * 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
  INFINITY: Infinity,
};
